"use client";

import Modal from "react-modal";

const resetModalStyle = (() => {
  // Styles
  const initial = null;

  const overlay = {
    position: initial,
    top: initial,
    left: initial,
    right: initial,
    bottom: initial,
    backgroundColor: initial,
    WebkitOverflowScrolling: initial,
    zIndex: initial,
  };

  const content = {
    position: initial,
    top: initial,
    left: initial,
    right: initial,
    bottom: initial,
    border: initial,
    background: initial,
    overflow: initial,
    borderRadius: initial,
    outline: initial,
    padding: initial,
  };

  return { overlay, content };
})();

const BlurModal = ({ isOpen, children, ...rest }) => {
  return (
    <Modal
      isOpen={isOpen}
      // isOpen={true}
      // onAfterOpen={afterOpenModal}
      // onRequestClose={closeModal}
      style={resetModalStyle}
      className="modal-blur"
      overlayClassName="modal-blur-overlay"
      shouldCloseOnOverlayClick={true}
      // overlayElement={
      //   (props, contentElement) => (
      //     <div {...props}>
      //       <a
      //         className="fixed top-4 right-4 w-4 h-4"
      //         href="#"
      //         onClick={(e) => {
      //           e.preventDefault();
      //           closeModal("collect");
      //         }}
      //       >
      //         <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 320 512">
      //           <path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" />
      //         </svg>
      //       </a>

      //       {contentElement}
      //     </div>
      //   )
      //   /* Custom Overlay element. */
      // }
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default BlurModal;
